import { IndexGenerator } from 'fractional-indexing-jittered';
import { mapValues } from 'lodash';
import { SortingQuestionPin, SortingQuestionPinLayoutTemplate, SortingQuestionTeacherPin } from '../../models';
import { stringToLeanProsemirror } from '../../tip-tap';
import { randomIds } from '../random-id';
import { PinCreationParams } from './pin-helper-types';

export const newSortingQuestionPin = (
  layoutTemplate: SortingQuestionPinLayoutTemplate
): PinCreationParams<SortingQuestionTeacherPin> => {
  const ids = randomIds(4);

  const orders = getSortingQuestionAnswerOrderGenerator([]).nKeysStart(4);

  return {
    type: 'SORTING_QUESTION',
    settings: {
      layout: layoutTemplate.key,
      layoutParts: mapValues(layoutTemplate.layoutParts, (comp) => comp?.id),
      backgroundColor: layoutTemplate.backgroundColor,
      backgroundImage: layoutTemplate.backgroundImage,
      questionId: layoutTemplate.layoutParts.TITLE?.id,
      answers: {
        [ids[0]]: {
          type: 'TEXT',
          text: stringToLeanProsemirror(''),
          shuffledOrder: orders[3],
          correctOrder: orders[2],
        },
        [ids[1]]: {
          type: 'TEXT',
          text: stringToLeanProsemirror(''),
          shuffledOrder: orders[2],
          correctOrder: orders[0],
        },
        [ids[2]]: {
          type: 'TEXT',
          text: stringToLeanProsemirror(''),
          shuffledOrder: orders[1],
          correctOrder: orders[3],
        },
        [ids[3]]: {
          type: 'TEXT',
          text: stringToLeanProsemirror(''),
          shuffledOrder: orders[0],
          correctOrder: orders[1],
        },
      },
    },
    teacherSettings: {},
    pinComponents: [...Object.values(layoutTemplate.layoutParts), ...layoutTemplate.pinComponents],
  };
};

export function getSortingQuestionAnswerOrderGenerator(orders: string[]): IndexGenerator {
  const sorted = [...orders].sort();
  return new IndexGenerator(sorted, { useJitter: true });
}

export function getShuffledSortingQuestionPinOrder(pin: SortingQuestionPin): string[] {
  return Object.entries(pin.settings.answers)
    .sort(([, a], [, b]) => {
      if (a.shuffledOrder < b.shuffledOrder) return -1;
      if (a.shuffledOrder > b.shuffledOrder) return 1;
      return 0;
    })
    .map(([id]) => id);
}

export function getCorrectSortingQuestionPinOrder(pin: SortingQuestionTeacherPin): string[] {
  return Object.entries(pin.settings.answers)
    .sort(([, a], [, b]) => {
      if (a.correctOrder < b.correctOrder) return -1;
      if (a.correctOrder > b.correctOrder) return 1;
      return 0;
    })
    .map(([id]) => id);
}
